import { render, staticRenderFns } from "./MicroStats.vue?vue&type=template&id=a1bc011c&scoped=true&"
import script from "./MicroStats.vue?vue&type=script&lang=js&"
export * from "./MicroStats.vue?vue&type=script&lang=js&"
import style0 from "./MicroStats.vue?vue&type=style&index=0&id=a1bc011c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bc011c",
  null
  
)

export default component.exports